import { string, object, number } from "yup";

const addressSchema = object().shape({
  rue: string().required("Addresse : le rue est obligatoire"),
  ville: string().required("Addresse : la ville est obligatoire"),
  codePostale: number()
    .typeError("Addresse : le code postale doit etre un nombre ")
    .min(1, "Addresse : le code postale est invalide")
    .required("Addresse : le code postale est obligatoire"),
  pays: string()
});

export default addressSchema;
